import React, { Component } from 'react';
import Help from '../generics/help';
import swal from 'sweetalert';
import moment from 'moment';
import { translate } from 'react-i18next';

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class DailyEquipment extends Component{
    constructor(props){
        super(props);

        this.onSearch = this.onSearch.bind(this);
        this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.generateExcel = this.generateExcel.bind(this);
		this.generatePDF = this.generatePDF.bind(this);

        this.state = {
            start_date:'',
            equipment_id:'all',
            equipments:[],
            work_sessions_id:'all',
            sessions:[],
            health_facilities_id:sessionStorage.getItem('health_facilities_id'),
            filename:'Bitacora Diaria por Equipo',
            listado:[],
            data:{
                medical_unit:'',
                center_key:'',
                date:'',
                equipment:'',
                session:''
            }
        }
    }

    componentDidMount(){
		//LINEA ANTERIOR: fetch(Config.default.apiGateway.URL+'equipments?type=analytical_test'
        fetch(Config.default.apiGateway.URL+'equipments?type=analytical_test', {
			method: 'GET',
		   	headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			} else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					equipments: response
				});
			}
	   });

		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'GET',
		   	headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			} else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					sessions: response
				});
			}
	   });

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
                end_date:date[2]+'-'+date[1]+'-'+date[0]
			});
		});
	}

    handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		
		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

    onSearch(){

		if(this.isValidForm()){
			
            var obj = {
                health_facilities_id: this.state.health_facilities_id,
                start_date:this.state.start_date,
                equipment_id:this.state.equipment_id,
                work_sessions_id:this.state.work_sessions_id
            }
            
            this.props.waiting.handleShow('Buscando...');
            fetch(Config.default.apiGateway.URL+'reports_imss/daily_equipment_log',{
                method: 'POST',
                body:JSON.stringify(obj),
                headers: new Headers({
                    'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                    'Accept'		: 'application/json',
                    'Content-Type'	: 'application/json'
                })
            }).then(res => {
                this.props.waiting.handleClose();

                if(res.ok){
                    return res.json();
                }else{
                    res.text().then((msg)=>{
                        swal('Error', msg, 'error');
                    });
                }
            }).then(async response => {
                if(response !== undefined){
                    var list = [];

                    let data = {
                        medical_unit:response.health_facility,
                        center_key:response.center_budget_key,
                        date:moment(response.date).format('DD/MM/YYYY'),
                        equipment:response.equipment,
                        session:response.work_session
                    };
                    
                    this.setState({
                        listado: response.equipment_logs,
                        data:data
                    });

                }
            });
            			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    generateExcel(e){
		e.preventDefault();

		this.props.waiting.handleShow('Generando Excel...');

		var obj = {
			health_facilities_id: this.state.health_facilities_id,
            start_date:this.state.start_date,
            equipment_id:this.state.equipment_id,
            work_sessions_id:this.state.work_sessions_id
		};

		fetch(Config.default.apiGateway.URL+'reports_imss/generate_excel?report_name=daily_equipment_log',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			this.props.waiting.handleClose();

			if(response !== undefined){
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		})
	}

	generatePDF(e) {
		e.preventDefault();

		var obj = {
			health_facilities_id: this.state.health_facilities_id,
            start_date:this.state.start_date,
            equipment_id:this.state.equipment_id,
            work_sessions_id:this.state.work_sessions_id
		};

		this.props.waiting.handleShow('Generando PDF...');
		fetch(Config.default.apiGateway.URL+'reports_imss/generate_pdf?report_name=daily_equipment_log',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var fileURL = URL.createObjectURL(response);
				window.open(fileURL);
			}
		})
	}

    render(){
        const {t} = this.props;
       
        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					IMSS ->
					{this.state.filename}
					</h5>
				</div>
            
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_daily_equipment_log"}  />
		        
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12"><span>Campos Requeridos (*)</span></div>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Fecha</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
                                <div className="form-group">
									<span className="span-min">Equipo</span>
									<select className="form-control" name="equipment_id" id="equipment_id" 
										value={this.state.equipment_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.equipments.map((w, i)=>{
											return <option key={i} value={w.equipment.id}>
												{w.equipment.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Sesión</span>
									<select className="form-control" name="work_sessions_id" id="work_sessions_id" 
										value={this.state.work_sessions_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.sessions.map((w, i)=>{
											return <option key={i} value={w.type}>
												{w.value}
											</option>
										})}
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.onSearch} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",fontSize: "20px"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
                                    {this.state.listado.length > 0 &&
                                    <>
                                        <div className='col-xs-12 form-group'>
                                            <div className='col-xs-12 col-sm-4 col-md-6'>
                                                <label style={{display:'block'}}>Unidad Médica</label>
                                                <span>{this.state.data.medical_unit}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-4 col-md-2'>
                                                <label style={{display:'block'}}>Clave Presupuestal</label>
                                                <span>{this.state.data.center_key}</span>
                                            </div>
                                        </div>

                                        <div className='col-xs-12 form-group'>
                                            <div className='col-xs-12 col-sm-4'>
                                                <label style={{marginRight:8}}>Fecha de realización</label>
                                                <span>{this.state.data.date}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-4'>
                                                <label style={{marginRight:8}}>Turno</label>
                                                <span>{this.state.data.session}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-4'>
                                                <label style={{marginRight:8}}>Equipo</label>
                                                <span>{this.state.data.equipment}</span>
                                            </div>
                                        </div>
                                    </>
                                    }
								</div>
                                <hr/>
								<div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.generateExcel(e)} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.generatePDF(e)}>PDF</button>
                                </div>

								<div className="col-xs-12 form-group" id="table-list">
                                    {this.state.listado.map((list, i)=>
                                        <div key={i}>
                                            <div className='col-xs-12 form-group'>
                                                <div className='col-xs-12 col-sm-3'>
                                                    <label style={{marginRight:8}}>Nombre</label>
                                                    <span>{list.equipment_brand}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-3'>
                                                    <label style={{marginRight:8}}>Marca</label>
                                                    <span>{list.equipment_name}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-3'>
                                                    <label style={{marginRight:8}}>No. de Serie del Equipo</label>
                                                    <span>{list.equipment_serial_number}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-3'>
                                                    <label style={{marginRight:8}}>Fecha de Fabricación</label>
                                                    <span>{list.equipment_manufacturing_date !== null ? moment(list.equipment_manufacturing_date).format('DD/MM/YYYY') : '' }</span>
                                                </div>
                                            </div>
                                            <div className="table-responsive col-xs-12">
                                                <table style={{fontSize:"10px !important"}} className="table table-hover expenses-discards" id="table-to-list">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width:50}}>No.</th>
                                                            <th style={{width:100}}>Folio Muestra</th>
                                                            <th style={{width:180}}>IDEE o NSS Paciente/Donador</th>
                                                            <th style={{width:60}}>Sexo</th>
                                                            <th style={{width:120}}>Fecha Nacimiento</th>
                                                            <th style={{width:120}}>Clave Estudio</th>
                                                            <th style={{width:100}}>Clave Prueba</th>
                                                            <th style={{width:150}}>Descripción Prueba</th>
                                                            <th style={{width:120}}>Resultado</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {list.records.map((rec, j)=>
                                                            <tr key={j}>
                                                                <td>{(j+1)}</td>
                                                                <td>{rec.sample_number}</td>
                                                                <td>{rec.person_idee}</td>
                                                                <td>{rec.person_sex}</td>
                                                                <td>{rec.person_birthday !== null ? moment(rec.person_birthday).format('DD/MM/YYYY') : ''}</td>
                                                                <td>{rec.section_code}</td>
                                                                <td>{rec.test_code}</td>
                                                                <td>{rec.test_name}</td>
                                                                <td>{rec.sample_result}</td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td colSpan={2}><b>Total de Pruebas Equipo {(i+1)}</b></td>
                                                            <td>{list.total}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
									
								</div>
							</div>
						</form>
					</div>
				</div>
            </div>
        )
    }
}

export default translate('translations') (DailyEquipment);